/**
 * @module events/types/mouseDown
 */

/**
 * @type {string}
 */
export default 'mousedown'
